import { render, staticRenderFns } from "./RegistrosAkashicosDetail.vue?vue&type=template&id=53ade8f8&scoped=true&"
import script from "./RegistrosAkashicosDetail.vue?vue&type=script&lang=js&"
export * from "./RegistrosAkashicosDetail.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosAkashicosDetail.vue?vue&type=style&index=0&id=53ade8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ade8f8",
  null
  
)

export default component.exports